export class Sorter {
    static byID(a, b) {
        if (a.id < b.id) {
            return -1;
        }
        if (a.id > b.id) {
            return 1;
        }
        return 0;
    }
    static byStringProperty(a, b, field) {
        return this.byStringValue(a[field], b[field]);
    }
    static byNumberProperty(a, b, field) {
        return this.byNumberValue(a[field], b[field]);
    }
    /**
     * Sort strings ASC order
     */
    static byStringValue(a, b) {
        const af = a.toLowerCase();
        const bf = b.toLowerCase();
        if (af > bf) {
            return 1;
        }
        if (af < bf) {
            return -1;
        }
        return 0;
    }
    static byBooleanValue(a, b) {
        if (a === b) {
            return 0;
        }
        if (a && !b) {
            return -1;
        }
        return 1;
    }
    static byEnumValue(a, b, enumObject) {
        return Object.values(enumObject).indexOf(a) - Object.values(enumObject).indexOf(b);
    }
    /**
     * Sort from large to small - DESC
     */
    static byNumberValue(a, b) {
        if (a === b) {
            return 0;
        }
        if (a > b) {
            return -1;
        }
        return 1;
    }
    /**
     * Sort from new to old - DESC
     */
    static byDateValue(a, b) {
        if (a.getTime() === b.getTime()) {
            return 0;
        }
        if (a > b) {
            return -1;
        }
        return 1;
    }
    /**
     * Return the first non zero value from a list, or zero if all values are zero
     */
    static stack(...sortResults) {
        while (sortResults.length > 0) {
            const f = sortResults.shift();
            if (f !== 0) {
                return f;
            }
        }
        return 0;
    }
    static getMostOccuringElement(array) {
        const counts = new Map();
        for (const element of array) {
            const count = counts.get(element);
            if (count) {
                counts.set(element, count + 1);
            }
            else {
                counts.set(element, 1);
            }
        }
        let maxCount = 0;
        let mostOccuringElement;
        for (const [element, count] of counts) {
            if (count > maxCount) {
                maxCount = count;
                mostOccuringElement = element;
            }
        }
        return mostOccuringElement;
    }
}
//# sourceMappingURL=Sorter.js.map